import React, { useContext, useMemo } from 'react';
import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  Select,
  TextField,
} from '@material-ui/core';
import { FormServiceContext } from 'app/utils/contexts';

import { Field } from 'formik';
import helpers from 'app/utils/helpers';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { useSelector } from 'react-redux';
import moment from 'moment';

function TravelInformation(props) {
  const { errors, touched, values, onChangeDate, classes } = props;
  const { canEdit, isInternalForm } = useContext(FormServiceContext);

  const cities = useSelector(state => state.forms.cities);
  const polos = useSelector(state => state.forms.polos);

  const currentDay = useMemo(() => moment().startOf('day'), []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <h3 className={classes.title}>Informações da viagem</h3>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl
          variant="filled"
          margin="dense"
          fullWidth
          disabled={!canEdit}
          error={!!errors.cdMunicipioSolicitacao && touched.cdMunicipioSolicitacao}
        >
          <InputLabel htmlFor="cdMunicipioSolicitacao" shrink={true}>Município da Solicitação</InputLabel>
          <Field
            name="cdMunicipioSolicitacao"
            id="cdMunicipioSolicitacao"
            native as={Select}
            disabled={isInternalForm}
            validate={value => {
              if (!value) {
                return 'Campo obrigatório';
              }
            }}
          >
            <option aria-label="None" value=""></option>
            {polos.map((c, index) => {
              return (
                <option key={`type-${index}`} value={c.cdMunicipio}>
                  {c.nmMunicipio}
                </option>
              );
            })}
          </Field>
          {errors.cdMunicipioSolicitacao && touched.cdMunicipioSolicitacao ? (
            <FormHelperText>{errors.cdMunicipioSolicitacao}</FormHelperText>
          ) : null}
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}></Grid>
      <Grid item xs={12} sm={4}>
        <Field
          name="dtViagem"
          label="Data da Viagem"
          format="DD/MM/YYYY"
          autoOk
          clearable
          clearLabel={'Limpar'}
          emptyLabel={''}
          value={helpers.formatarData(values.dtViagem)}
          invalidLabel="Data inválida"
          invalidDateMessage="Data inválida"
          maxDateMessage="Data inválida"
          minDateMessage="Data inválida"
          minDate={currentDay}
          margin="dense"
          disabled={!canEdit}
          onChange={v => onChangeDate(values, 'dtViagem', v)}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          inputVariant="filled"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          error={!!errors.dtViagem && touched.dtViagem}
          helperText={errors.dtViagem && touched.dtViagem ? errors.dtViagem : ''}
          as={KeyboardDatePicker}
          validate={value => {
            const startDate = moment(value);
            const returnDate = moment(values.dtRetorno);

            if (!startDate) {
              return 'Campo obrigatório';
            }
            if (startDate.isBefore(currentDay)) {
              return 'Data da viagem precisa ser maior ou igual a data de hoje';
            }
            if (returnDate && startDate.isAfter(returnDate)) {
              return 'Data da viagem não pode ser maior que a data de retorno';
            }
          }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Field
          name="dtRetorno"
          label="Data do Retorno"
          format="DD/MM/YYYY"
          autoOk
          clearable
          clearLabel={'Limpar'}
          emptyLabel={''}
          value={helpers.formatarData(values.dtRetorno)}
          invalidLabel="Data inválida"
          invalidDateMessage="Data inválida"
          maxDateMessage="Data inválida"
          minDateMessage="Data inválida"
          minDate={values.dtViagem ? helpers.formatarData(values.dtViagem) : currentDay}
          margin="dense"
          disabled={!canEdit}
          onChange={v => onChangeDate(values, 'dtRetorno', v)}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          inputVariant="filled"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          error={!!errors.dtRetorno && touched.dtRetorno}
          helperText={errors.dtRetorno && touched.dtRetorno ? errors.dtRetorno : ''}
          as={KeyboardDatePicker}
          validate={value => {

            const startDate = moment(values.dtViagem);
            const returnDate = moment(value)

            if (!returnDate) {
              return 'Campo obrigatório';
            }
            if (returnDate.isBefore(currentDay)) {
              return 'Data de retorno precisa ser maior ou igual a data de hoje';
            }
            if (startDate && returnDate.isBefore(startDate)) {
              return 'Data da retorno não pode ser menor que a data da viagem';
            }
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl
          variant="filled"
          margin="dense"
          fullWidth
          disabled={!canEdit}
          error={!!errors.cdMunicipioOrigem && touched.cdMunicipioOrigem}
        >
          <InputLabel htmlFor="cdMunicipioOrigem" shrink={true}>Cidade origem</InputLabel>
          <Field
            name="cdMunicipioOrigem"
            id="cdMunicipioOrigem"
            native
            as={Select}
            validate={value => {
              if (!value) {
                return 'Campo obrigatório';
              }

              if (value === values.cdMunicipioDestino) {
                return 'A cidade origem não pode ser igual a cidade destino';
              }
            }}
          >
            <option aria-label="None" value=""></option>
            {cities.map((c, index) => {
              return (
                <option key={`type-${index}`} value={c.cdMunicipio}>
                  {c.nmMunicipio}
                </option>
              );
            })}
          </Field>
          {errors.cdMunicipioOrigem && touched.cdMunicipioOrigem ? (
            <FormHelperText>{errors.cdMunicipioOrigem}</FormHelperText>
          ) : null}
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl
          variant="filled"
          margin="dense"
          fullWidth
          disabled={!canEdit}
          error={!!errors.cdMunicipioDestino && touched.cdMunicipioDestino}
        >
          <InputLabel htmlFor="cdMunicipioDestino" shrink={true}>Cidade destino</InputLabel>
          <Field
            name="cdMunicipioDestino"
            id="cdMunicipioDestino"
            native
            as={Select}
            validate={value => {
              if (!value) {
                return 'Campo obrigatório';
              }

              if (value === values.cdMunicipioOrigem) {
                return 'A cidade destino não pode ser igual a cidade origem';
              }
            }}
          >
            <option aria-label="None" value=""></option>
            {cities.map((c, index) => {
              return (
                <option key={`type-${index}`} value={c.cdMunicipio}>
                  {c.nmMunicipio}
                </option>
              );
            })}
          </Field>
          {errors.cdMunicipioDestino && touched.cdMunicipioDestino ? (
            <FormHelperText>{errors.cdMunicipioDestino}</FormHelperText>
          ) : null}
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Field
          name="dePreposto"
          label="Preposto"
          variant="filled"
          margin="dense"
          disabled={!canEdit}
          fullWidth
          // error={!!errors.nmFantasia}
          // helperText={errors.nmFantasia && touched.nmFantasia ? errors.nmFantasia : ''}
          as={TextField}
          inputProps={{
            maxLength: 150,
          }}
        />
      </Grid>
    </Grid>
  );
}

export default TravelInformation;
